import { SITE_MENU_VERTICAL_SPACING_MULTIPLIER } from 'omakase/SiteMenuTopLevelHeading/siteMenuTopLevelHeadingCssDefs';
import { Theme, css } from '@emotion/react';

/**
 * The root component class
 */
export const siteMenuRootContainer = ({ breakpoints, colors, spacing }: Theme) => css`
  align-items: center;
  background-color: ${colors.bgDefault};
  display: flex;
  flex-direction: column;
  overflow: auto;
  // For bottom padding, we use the same value as for top padding for the logged out state
  padding-bottom: ${spacing(5)}px;
  width: 100%;
  ${breakpoints.up('sm')} {
    padding-bottom: ${spacing(4.5)}px;
  }
`;

export const siteMenuNestedContent = ({ timings: { duration, timingFunction } }: Theme) => css`
  /*
   * the "onscreen" style of the content.
   */
  --x-position: 0;
  transform: translateX(var(--x-position)) translateZ(0);
  transition: transform ${duration.shortest} ${timingFunction.easeInOut};
  /* 
   * the base "-enter" and "-exit" classes exist for the duration of the transition.
   */
  &.site-menu-nested-enter,
  &.site-menu-nested-exit {
    position: absolute;
  }
  /* 
   * "-active" classes applied on top of the base to trigger the change.
   */
  &.site-menu-nested-enter:not(.site-menu-nested-enter-active),
  &.site-menu-nested-exit-active {
    --x-position: 100%;
  }
`;

export const siteMenuBaseContent = ({ timings: { duration, timingFunction } }: Theme) => css`
  /*
   * the "onscreen" style of the content.
   */
  --x-position: 0;
  transform: translateX(var(--x-position)) translateZ(0);
  transition: transform ${duration.shortest} ${timingFunction.easeInOut};
  /*
   * the base "-enter" and "-exit" classes exist for the duration of the transition.
   */
  &.site-menu-enter,
  &.site-menu-exit {
    position: absolute;
  }
  /*
   * "-active" classes applied on top of the base to trigger the change.
   */
  &.site-menu-enter:not(.site-menu-enter-active),
  &.site-menu-exit-active {
    --x-position: -100%;
  }
`;

/**
 * Style for back button that renders on nested menu content
 */

export const siteMenuBackButtonContainer = ({ spacing }: Theme) => css`
  padding-top: ${spacing(SITE_MENU_VERTICAL_SPACING_MULTIPLIER)}px;
  margin-right: 0;
  margin-bottom: ${spacing(7.5)}px;
  margin-left: 0;
  width: 100%;
`;
